// Vocabulary "images" — keyed by the Croatian word so the image-choice
// generator can look up coverage instantly.
//
// Each value is either an emoji (rendered at large size in the tile, our
// current default — universal, free, license-clean, zero asset payload)
// or a URL string starting with `/` (rendered as <img>). The component
// detects which by checking the first character. Swap in real WebPs
// later by replacing values like `'🐶'` with `'/images/vocab/dog.webp'`.

export const imageMap = {
  // food
  'voda': '💧',
  'kruh': '🍞',
  'mlijeko': '🥛',
  'jabuka': '🍎',
  'riba': '🐟',
  'meso': '🥩',
  'sir': '🧀',
  'jaje': '🥚',
  'kava': '☕',
  'čaj': '🍵',
  'pivo': '🍺',
  'vino': '🍷',
  'šećer': '🍬',
  'sol': '🧂',
  // animals
  'pas': '🐶',
  'mačka': '🐱',
  'ptica': '🐦',
  'konj': '🐴',
  'krava': '🐄',
  'miš': '🐭',
  'medvjed': '🐻',
  'vuk': '🐺',
  'lav': '🦁',
  'svinja': '🐷',
  // house
  'kuća': '🏠',
  'vrata': '🚪',
  'prozor': '🪟',
  'stol': '🪑',
  'krevet': '🛏️',
  'kuhinja': '🍳',
  'kupaonica': '🛁',
  // weather / nature
  'sunce': '☀️',
  'kiša': '🌧️',
  'snijeg': '❄️',
  'more': '🌊',
  // travel
  'vlak': '🚆',
  'auto': '🚗',
};

export function hasImage(hr) {
  return Boolean(imageMap[hr]);
}

export function imageFor(hr) {
  return imageMap[hr];
}
